import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EUserType } from '../enums/EUserType';
import { IUser } from '../interfaces/IUser';
import { UtilsService } from "./utils.service";

@Injectable({ providedIn: 'root' })
export class NavigationService {
    constructor(private router: Router, private utilsService: UtilsService) {
    }

    async gotoDashboard(gUser: IUser) {
        console.log(gUser);
        if (!gUser) return;
        await this.router.navigate(['/root-dashboard']);
        // switch (gUser.usr_type_str) {
        //     case EUserType.ROOT: {
        //         await this.router.navigate(['/root-dashboard']);
        //         break;
        //     }
        //     case EUserType.ADMIN: {
        //         await this.router.navigate(['/root-dashboard']);
        //         break;
        //     }
        //     default:{
        //         break;
        //     }
        // }
    }
}
